export default function RightSidebar({ active = false, content = <></> }) {
  return (
    <div className={`right-sidebar ${active === true ? "active" : ""}`}>
      <div className="right-sidebar-overlay"></div>
      <div className="right-sidebar-content">{content}</div>
    </div>
  );
}
